import { throwError as observableThrowError } from "rxjs"

import { HttpClient, HttpHeaders } from "@angular/common/http"
import { Injectable } from "@angular/core"
import { catchError } from "rxjs/operators"
import { LmApiService } from "./lm-api.service"

@Injectable()
export class FooterService {
    constructor(private http: HttpClient, private lmApi: LmApiService) {}

    public subscribeToNewsletter(url: string, formName: string, siteId: string, email: string) {
        const formData: URLSearchParams = new URLSearchParams()
        formData.set("elqFormName", formName)
        formData.set("elqSiteId", siteId)
        formData.set("emailAddress", email)
        return this.http
            .post(url, formData.toString(), {
                headers: new HttpHeaders().set("Content-Type", "application/x-www-form-urlencoded"),
                responseType: "text",
            })
            .pipe(catchError((error) => observableThrowError(error)))
    }

    public getFeedbackFormHtml() {
        return this.lmApi
            .get("/feedback/submit/", { responseType: "text" })
            .pipe(catchError((error) => observableThrowError(error)))
    }

    public submitFeedback(
        csrfmiddlewaretoken: string,
        name: string,
        email: string,
        comment: string,
        captchaResponse: string
    ) {
        const formData: URLSearchParams = new URLSearchParams()
        formData.set("csrfmiddlewaretoken", csrfmiddlewaretoken)
        formData.set("name", name)
        formData.set("email", email)
        formData.set("comment", comment)
        formData.set("g-recaptcha-response", captchaResponse)
        return this.lmApi
            .post("/feedback/submit/", formData.toString(), {
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                },
                responseType: "text",
            })
            .pipe(catchError((error) => observableThrowError(error)))
    }
}
